import React, { useState, useEffect } from "react";
import { Card, Row, Col, Spinner, Alert, Container } from "react-bootstrap";
import { getDashboardPrincipal } from "../../../services/endpoints";
import { CurrencyDollar, CalendarCheck, CalendarX, Speedometer } from "react-bootstrap-icons";
import { useColors } from "../../../contexts/ColorContext";

function DashboardFuncionario({ usuario, idClienteMaster }) {
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!idClienteMaster || !usuario?.id) return;

        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                const dash = await getDashboardPrincipal(idClienteMaster, usuario.id);
                setDashboardData(dash);

            } catch (err) {
                console.error("Erro ao buscar dados do Dashboard do Funcionário:", err);
                setError("Não foi possível carregar os dados do dashboard.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [idClienteMaster, usuario]);

    if (loading) {
        return (
            <div className="text-center p-5">
                <Spinner animation="border" />
                <p className="mt-2">Carregando Dashboard...</p>
            </div>
        );
    }

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    return (
        <Container fluid>
            <h2 className="mb-4">Dashboard</h2>

            <Row className="mb-4 g-3">
                <Col md={6} lg={4} className="mb-3">
                    <MetricCard
                        title="Agendamentos Hoje"
                        value={dashboardData.agendamentosHoje}
                        icon={<CalendarCheck size={30} />}
                        variant="primary"
                    />
                </Col>
                <Col md={6} lg={4} className="mb-3">
                    <MetricCard
                        title="Lucro do Dia"
                        value={`R$ ${dashboardData.lucroDia.toFixed(2).replace('.', ',')}`}
                        icon={<CurrencyDollar size={30} />}
                        variant="success"
                    />
                </Col>
                <Col md={6} lg={4} className="mb-3">
                    <MetricCard
                        title="Agendamentos Pendentes"
                        value={dashboardData.agendamentosPendentes}
                        icon={<CalendarX size={30} />}
                        variant="success"
                    />
                </Col>
            </Row>

            <Row className="mb-4 g-3">
                <Col md={6} lg={4} className="mb-3">
                    <MetricCard
                        title="Agendamentos Mês"
                        value={dashboardData.agendamentosMesRealizados}
                        icon={<CalendarCheck size={30} />}
                        variant="info"
                    />
                </Col>
                <Col md={6} lg={4} className="mb-3">
                    <MetricCard
                        title="Lucro do Mês"
                        value={`R$ ${dashboardData.lucroMes.toFixed(2).replace('.', ',')}`}
                        icon={<CurrencyDollar size={30} />}
                        variant="success"
                    />
                </Col>
            </Row> 
        </Container>
    );
}

// COMPONENTE AUXILIAR
const MetricCard = ({ title, value, icon, variant }) => {
    const { colors } = useColors();
    const { primaryColor, secondaryColor, cardBackgroundColor, cardTextColor } = colors;

    let cardBg = cardBackgroundColor;
    let cardText = cardTextColor;

    if (variant === "primary") {
        cardBg = primaryColor;
        cardText = colors.btnTextColor || "#fff";
    } else if (variant === "secondary") {
        cardBg = secondaryColor;
        cardText = colors.btnTextColor || "#fff";
    } else if (variant === "success") {
        cardBg = "#28a745";
        cardText = "#fff";
    } else if (variant === "warning") {
        cardBg = "#ffc107";
        cardText = "#212529";
    } else if (variant === "info") {
        cardBg = "#17a2b8";
        cardText = "#fff";
    }

    const cardStyle = {
        backgroundColor: cardBg,
        color: cardText,
        borderColor: cardBg,
        transition: "all 0.3s ease"
    };

    return (
        <Card className="shadow-sm" style={cardStyle}>
            <Card.Body>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <Card.Title className="h5 mb-0" style={{ color: cardText }}>{value}</Card.Title>
                        <Card.Text style={{ color: cardText }}>{title}</Card.Text>
                    </div>

                    {/* PREVENÇÃO DO ERRO — só clona se existir */}
                    {icon ? React.cloneElement(icon, { color: cardText }) : null}
                </div>
            </Card.Body>
        </Card>
    );
};

export default DashboardFuncionario;
